export const aciEdit = {
    iconName: 'edit',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M17.258 3.036a3.324 3.324 0 00-1.452.626c-.138.104-11.38 11.33-11.417 11.402-.014.027-.332 1.246-.707 2.71C3.187 19.708 3 20.467 3 20.543c0 .13.047.235.146.329.095.09.19.13.317.13.07 0 .905-.206 2.716-.67l2.69-.69c.067-.019.81-.754 5.618-5.56 3.048-3.046 5.615-5.619 5.704-5.718a3.28 3.28 0 00.754-1.505c.052-.246.072-.778.038-1.031a3.24 3.24 0 00-.922-1.887 3.246 3.246 0 00-1.869-.921 4.11 4.11 0 00-.934.017zm.143.95a2.295 2.295 0 00-1.145.553l-.083.076 1.605 1.604 1.604 1.605.046-.043c.14-.13.345-.448.442-.688.124-.308.174-.555.174-.867a2.261 2.261 0 00-1.896-2.24 2.643 2.643 0 00-.747 0zm-6.904 6.31L5.5 15.294l1.604 1.604 1.604 1.604 4.998-4.999 4.999-4.998L17.1 6.9l-1.604-1.604-4.999 4.999zM5.051 16.3c-.228.872-.903 3.538-.896 3.545.009.008 3.508-.88 3.58-.91.027-.01-.24-.287-1.315-1.361L5.07 16.226l-.02.075z',
                fill: 'currentColor',
            },
        },
    },
};
